import type { AnnotationPoint } from '@v2/components/imageHandling/components/DrawingCanvas/types';

/** Builds an SVG `d` attribute from a list of points using M/L commands. */
export const getSvgPathFromPoints = (points: AnnotationPoint[]): string => {
  if (points.length === 0) return '';
  return points.map((p, i) => `${i === 0 ? 'M' : 'L'}${p.x.toFixed(2)},${p.y.toFixed(2)}`).join(' ');
};
